
    import { defineComponent, type PropType } from 'vue'

    import { Staff } from '@/common/models/data/dashboard/staff/staff'
    import { staffData } from '@/common/json-ld/organization'

    export default defineComponent({
        props: {
            entry: {
                type: Object as PropType<Staff>,
                required: true
            }
        },

        setup (props) {
            const jsonLd = staffData(props.entry)

            return {
                jsonLd
            }
        }
    })
